import {
  MODULE_LOADING,
  MODULE_ADD,
  MODULE_UPDATE,
  MODULE_DELETE,
  MODULE_LIST,
} from "actions/module/types";

const initialState = {
  loading: false,
  list: {
    content: []
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MODULE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case MODULE_ADD:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          content: state.list.content.concat(action.payload)
        }
      };
    case MODULE_UPDATE:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          content: state.list.content
            .splice(state.list.content.findIndex(item => item.id === action.payload.id), 1, action.payload)
        },
      };
    case MODULE_DELETE:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          content: state.list.content.filter(i => i.id !== action.payload.id)
        },
      };
    case MODULE_LIST:
      return {
        ...state,
        loading: false,
        list: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/moduleReducer.js